import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useTerminal } from "@/lib/terminal";
import { errMsg } from "@/lib/api";

const toList = (s) => s.split(",").map((x) => Number(x.trim())).filter((x) => x > 0);

export const SettingsCard = () => {
  const { api, settings, setSettings } = useTerminal();
  const [buy, setBuy] = useState("");
  const [sell, setSell] = useState("");
  const [slip, setSlip] = useState(0);
  useEffect(() => {
    setBuy(settings.buy_presets.join(", ")); setSell(settings.sell_presets.join(", ")); setSlip(settings.slippage_bps / 100);
  }, [settings]);
  const save = async () => {
    try {
      const r = await api("put", "/settings", { buy_presets: toList(buy), sell_presets: toList(sell).map(Math.round), slippage_bps: Math.round(Number(slip) * 100) });
      setSettings(r); toast.success("Trade ayarları kaydedildi");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const cls = "w-full h-9 px-2.5 rounded border border-[#222634] bg-[#161920] font-mono text-sm outline-none focus:border-[#333A4E]";
  return (
    <div className="p-4 rounded-md border border-[#222634] bg-[#101216] space-y-3">
      <h2 className="text-sm font-semibold">Manuel Trade Ayarları</h2>
      <label className="block text-xs text-slate-400 space-y-1">Alım butonları (ETH, virgülle)<input data-testid="settings-buy-presets" className={cls} value={buy} onChange={(e) => setBuy(e.target.value)} /></label>
      <label className="block text-xs text-slate-400 space-y-1">Satış butonları (%)<input data-testid="settings-sell-presets" className={cls} value={sell} onChange={(e) => setSell(e.target.value)} /></label>
      <label className="block text-xs text-slate-400 space-y-1">Kayma toleransı (%)<input data-testid="settings-slippage" type="number" className={cls} value={slip} onChange={(e) => setSlip(e.target.value)} /></label>
      <button data-testid="settings-save-button" onClick={save} className="w-full h-9 rounded border border-[#333A4E] hover:bg-[#161920] text-sm transition-colors">Kaydet</button>
    </div>
  );
};
